import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Logo({ size = 'md', className = '' }: LogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl'
  };
  return (
    <div
      className={`font-serif font-bold tracking-tight ${sizeClasses[size]} ${className} flex items-center gap-2`}>
      <span>
        <span className="text-white">Geniac</span>
        <span className="text-amber">.io</span>
      </span>
      <span className="text-[10px] font-sans font-semibold uppercase tracking-wider text-amber/70 border border-amber/30 rounded px-1.5 py-0.5 leading-none">beta</span>
    </div>);

}